import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";

import { ClientFormatMoneyPriceWrapperProps } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/ClientFormatMoneyPriceWrapperProps";
import { PriceWithClientFormatMoney } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/PriceWithClientFormatMoney";
import { ProductName } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { ProductTileSwatches } from "../../../ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { ITrackingProps, ProductTileSwatchesProps } from "../../types";

import { ProductLink } from "./ProductLink";
import { SwatchGroup } from "./Swatch/SwatchGroup";

export const ProductTileNameAndPrice = ({
  priceTextProps,
  productName,
  productTileSwatchesProps,
  trackingProps,
}: {
  priceTextProps?: ClientFormatMoneyPriceWrapperProps;
  productName: string;
  productTileSwatchesProps?: ProductTileSwatchesProps;
  trackingProps: ITrackingProps;
}) => {
  const hasSwatches =
    productTileSwatchesProps?.optionDetails?.swatch_details
      ?.swatches_and_options &&
    productTileSwatchesProps?.optionDetails?.swatch_details
      ?.swatches_and_options?.length > 0;

  return (
    <>
      <Spacer size="1x" />
      {hasSwatches ? (
        <SwatchGroup
          optionDetails={productTileSwatchesProps?.optionDetails}
          productToken={trackingProps.productToken ?? ""}
          impressionId={trackingProps.impressionId}
          promotedBy={trackingProps.promotedBy}
          isPromoted={trackingProps.isPromoted}
          brandToken={trackingProps.brandToken}
        />
      ) : null}
      <ProductLink dataTestId="product-tile-product-information">
        <Column gap={2}>
          {priceTextProps && priceTextProps?.isLoggedInOrBrandPreview ? (
            <PriceWithClientFormatMoney {...priceTextProps} />
          ) : null}
          <ProductName
            productName={productName}
            oneLineBreak={!priceTextProps?.isLoggedInOrBrandPreview}
          />
          {priceTextProps && !priceTextProps?.isLoggedInOrBrandPreview ? (
            <PriceWithClientFormatMoney {...priceTextProps} />
          ) : null}
          <ProductTileSwatches
            optionDetails={productTileSwatchesProps?.optionDetails}
          />
        </Column>
      </ProductLink>
    </>
  );
};
